import { useKeycloak } from '@react-keycloak/web'

import PrivateRouter from './PrivateRouter'

const AppRouter = () => {
  const { keycloak } = useKeycloak()

  return keycloak.authenticated ? <PrivateRouter /> : <></>
}

export default AppRouter
